module.exports = __webpack_public_path__ + "img/dron.70b30d72.svg";